<template>
    <div id="app" :class="drawerStatus == false ? '' : 'small'">
        <div id="header">
            <div id="header-accueil" class="barre-header">
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 retour no-padding" style="float: left;">
                    <div class="logo">
                        <div v-if="needReturn" @click="back()" style="padding-right: 10px; float: left; line-height: 50px;"><font-awesome-icon icon="chevron-left" style="font-size: 20px; cursor: pointer;"></font-awesome-icon></div>
<!--                        <img src="./assets/logo/saintjean_logo.svg" />-->
                    </div>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8 text-center no-padding title-header" style="float: left;">
                    {{$route.meta.title}}
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 text-right no-padding" style="float: left;">
                    <div class="btn-alerts" v-if="isAuthenticated">
                        <font-awesome-icon icon="bell"></font-awesome-icon>
                        <div class="counter-alert">{{demandes.length}}</div>
                    </div>
                    <a v-if="isAuthenticated" href="#" id="btnDeco" class="btn-deco" title="Déconnexion" @click="logout()">
                        <font-awesome-icon icon="power-off"></font-awesome-icon>
                    </a>
                </div>
            </div>
        </div>
        <b-overlay variant="dark" no-wrap :show="overlay" opacity="0.7">
            <template v-slot:overlay>
                <b-card class="text-center" style="width: 300px;">
                    <b-card-text class="text-center">
                        <div class="mb-4">
                            <b-spinner
                                style="width: 4.5rem; height: 4.5rem;"
                                variant="primary"
                                label="Chargement..."
                            ></b-spinner>
                        </div>
                        <div class="text-center">
                            <span style="font-size:1.5rem;color: #000000;">Chargement...</span>
                        </div>
                    </b-card-text>
                </b-card>
            </template>
        </b-overlay>
        <router-view :key="$route.fullPath"></router-view>
    </div>
</template>

<script>
    import Vuex from "vuex";
    import router from "./router/index.js";

    export default {
        name: "App",
        data: () => ({
            overlay: false,
        }),
        methods: {
            logout() {
                this.logout();
            },
            toProfil() {
                router.push({name: "Profil"});
            },
            showSpinner() {
                this.overlay = true;
            },
            hideSpinner() {
                this.overlay = false;
            },
            ...Vuex.mapActions("Authentification", [
                "getUserConnected",
                "logout",
            ]),
            back() {
                window.history.back();
            }
        },
        computed: {
            ...Vuex.mapGetters("Authentification", ["drawerStatus", "isAuthenticated"]),
            ...Vuex.mapGetters("Application", ['needReturn'])
        },
        created() {
            window.Event.$on("before-request", this.showSpinner);
            window.Event.$on("request-error", this.hideSpinner);
            window.Event.$on("after-response", this.hideSpinner);
            window.Event.$on("response-error", this.hideSpinner);
        },
        beforeDestroy() {
            window.Event.$off("before-request", this.showSpinner);
            window.Event.$off("request-error", this.hideSpinner);
            window.Event.$off("after-response", this.hideSpinner);
            window.Event.$off("response-error", this.hideSpinner);
        },
    };
</script>

<style>
    @import "./styles/index.scss";
</style>
